module.exports = __webpack_public_path__ + "static/media/SushiRollTeaser.86ba7393.jpg";